import { useMutation, useQueryClient } from '@tanstack/react-query';

import { aiIncidentsApi } from '../api/aiIncidents';
import { aiIncidentsQueryKeys } from './queryKeys';

export const useConvertAiIncidentToIncident = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: aiIncidentsApi.convertAiIncidentToIncident,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: aiIncidentsQueryKeys.all });
    },
  });
};
